import { useMutation, useQueryClient } from "@tanstack/react-query";
import axios from "axios";

const updateLearningPathApi = async ({ uid, requestData }) => {
  const response = await axios.put(
    `${process.env.NEXT_PUBLIC_BASE_URL}/v1/users/learning-paths/${uid}`,
    requestData,
    {
      headers: { "Content-Type": "application/json" },
      withCredentials: true,
    }
  );
  return response.data;
};

export const useUpdateLearningPath = (learningPath) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: updateLearningPathApi,
    onSuccess: (data, variables) => {
      if (learningPath) {
        queryClient.invalidateQueries(["learningPath", variables.uid]);
      }
    },
    onError: (error) => {
      console.error("Update failed:", error);
    },
  });
};

export default useUpdateLearningPath;
